// extracted by mini-css-extract-plugin
var _1 = "MyTradesPageStyle-module__header___NFM2T";
var _2 = "MyTradesPageStyle-module__link-container___i5t16";
var _3 = "MyTradesPageStyle-module__link-container___i5t16";
var _4 = "MyTradesPageStyle-module__loader-container___kQJEW";
var _5 = "MyTradesPageStyle-module__loader-container___kQJEW";
var _6 = "MyTradesPageStyle-module__title___aYBKx";
var _7 = "MyTradesPageStyle-module__trades-container___YjVic";
var _8 = "MyTradesPageStyle-module__trades-container___YjVic";
export { _1 as "header", _2 as "link-container", _3 as "linkContainer", _4 as "loader-container", _5 as "loaderContainer", _6 as "title", _7 as "trades-container", _8 as "tradesContainer" }
